import React from 'react'
import classnames from 'classnames'

import SkeletonTile from '../../SkeletonTile/SkeletonTile'
import { getTableCellStyle } from '../TableHelper'


const TableRowLoading = (props) => {
  const {
    viewBy,
    equalWidthColumns,
    style,
    headerGroups,
    columnWidthsObjectProp,
    columnWidthsObjectState,
    isResizable,
    columnResizing,
    tableRowAction
  } = props
  return (
    <div
      className={
        'Table__body__row ' +
        (viewBy === 'Compact' ? 'Table__body__row--compact ' : '') +
        (equalWidthColumns ? 'Table__body__row--equal-width-columns' : '' + 'Table__body__row-loading')
      }
      style={style}>
      {Array.isArray(headerGroups) &&
        headerGroups.length > 0 &&
        headerGroups[0].headers.map((column: any, loadingIndex) => {
          let cellProps = column.getHeaderProps()

          if (column.id === 'selection') {
            return (
              <div
                key={loadingIndex}
                className={classnames('Table-select-body flex-center', props.canFreezeCheckbox && 'freezed')}>
                <div className="skeleton-square"></div>
              </div>
            )
          }

          const { width } = getTableCellStyle({
            column: column,
            columns: props.columns,
            cellProps: cellProps,
            columnWidthsObjectState,
            columnWidthsObjectProp,
            equalWidthColumns,
            columnResizing,
            isResizable,
            tableRowAction
          })
          return (
            <div
              key={loadingIndex}
              className={classnames(
                'Table__body__column flex-center',
                !!column.cssClass && column.cssClass,
                column.id === 'tableActions' && props.tableRowAction && 'Table__body__cell--tableRowAction'
              )}
              style={{ width }}>
              <SkeletonTile
                numberOfTiles={1}
                tileHeight={10}
                tileWidth={80}
                tileBottomSpace={7}
                tileTopSpace={5}
                tileleftSpace={5}
              />
            </div>
          )
        })}
    </div>
  )
}


export default TableRowLoading